import { render, staticRenderFns } from "./UserImportationBatch.vue?vue&type=template&id=b183a870"
import script from "./UserImportationBatch.vue?vue&type=script&lang=js"
export * from "./UserImportationBatch.vue?vue&type=script&lang=js"
import style0 from "./UserImportationBatch.vue?vue&type=style&index=0&id=b183a870&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports